<template>
  <v-dialog :value="!!state" max-width="460" persistent @input="v => !v && cancel()">
    <div v-if="state" class="md">
      <header class="md__head" :style="{ '--sc': state.stage.color || stageColor }">
        <span class="md__icon">
          <v-icon :color="isLost ? 'error' : (isWon ? 'success' : 'primary')">
            {{ isLost ? 'mdi-close-octagon-outline' : (isWon ? 'mdi-trophy-outline' : 'mdi-form-select') }}
          </v-icon>
        </span>
        <div>
          <div class="md__title">{{ isLost ? $t('crmMarkLost') : (isWon ? $t('crmMarkWon') : $t('crmCompleteFields')) }}</div>
          <div class="md__sub">{{ state.deal.title }} ← {{ state.stage.title }}</div>
        </div>
      </header>
      <div class="md__body">
        <v-alert v-if="state.message" type="warning" text dense>{{ state.message }}</v-alert>
        <template v-if="isLost">
          <div class="md__reasons">
            <button
              v-for="r in reasons"
              :key="r.id"
              type="button"
              class="md__reason"
              :class="{ 'md__reason--on': reasonId === r.id }"
              @click="reasonId = r.id; reasonText = ''"
            >{{ r.title }}</button>
          </div>
          <v-text-field v-model="reasonText" :label="$t('crmOtherReason')" outlined dense hide-details class="mt-4" @input="reasonId = null" />
        </template>
        <v-text-field v-if="isWon" v-model="wonReason" :label="$t('crmWonReason')" outlined dense hide-details />
        <div v-for="fld in state.missing || []" :key="fld.field_id" class="mt-4">
          <v-text-field v-model="cf[fld.field_id]" :label="fld.label + ' *'" outlined dense hide-details />
        </div>
        <v-textarea v-model="note" :label="$t('crmNote')" outlined dense hide-details rows="2" auto-grow class="mt-4" />
      </div>
      <footer class="md__foot">
        <v-btn :color="isLost ? 'error' : 'primary'" depressed class="app-form-action-btn" :disabled="!valid" @click="confirm">
          {{ $t('crmConfirm') }}
        </v-btn>
        <v-btn color="grey" outlined class="app-form-action-btn" @click="cancel">{{ $t('crmCancel') }}</v-btn>
      </footer>
    </div>
  </v-dialog>
</template>

<script>
import { crm } from '../crmStore'

export default {
  name: 'CrmMoveDialog',
  // state: { deal, stage, missing?, message?, resolve(payload|null) }
  props: { state: { type: Object, default: null } },
  data: () => ({ reasonId: null, reasonText: '', wonReason: '', note: '', cf: {} }),
  computed: {
    isLost () { return this.state && this.state.stage.kind === 'lost' },
    isWon () { return this.state && this.state.stage.kind === 'won' },
    reasons () { return crm.lossReasons },
    stageColor () { return '#2166d1' },
    valid () {
      if (!this.state) return false
      if (this.isLost && !this.reasonId && !this.reasonText.trim()) return false
      return (this.state.missing || []).every(f => String(this.cf[f.field_id] || '').trim())
    }
  },
  watch: {
    state (v) {
      if (!v) return
      this.reasonId = null
      this.reasonText = ''
      this.wonReason = ''
      this.note = ''
      this.cf = {}
    }
  },
  methods: {
    confirm () {
      const p = { stage_id: this.state.stage.id }
      if (this.isLost) {
        if (this.reasonId) p.loss_reason_id = this.reasonId
        else p.loss_reason = this.reasonText.trim()
      }
      if (this.isWon && this.wonReason) p.won_reason = this.wonReason
      if (this.note) p.note = this.note
      if (Object.keys(this.cf).length) p.custom_fields = { ...this.cf }
      this.state.resolve(p)
    },
    cancel () { this.state && this.state.resolve(null) }
  }
}
</script>

<style scoped>
.md { background: #fff; border-radius: 6px; overflow: hidden; }
.theme--dark .md { background: #1e1e1e; }
.md__head { display: flex; align-items: center; gap: 12px; padding: 14px 18px; border-bottom: 1px solid rgba(15, 23, 42, .07); border-top: 3px solid var(--sc); }
.md__icon { width: 40px; height: 40px; border-radius: 6px; background: rgba(127, 127, 127, .1); display: flex; align-items: center; justify-content: center; }
.md__title { font-weight: 700; }
.md__sub { font-size: .78rem; opacity: .6; }
.md__body { padding: 18px; }
.md__reasons { display: flex; flex-wrap: wrap; gap: 8px; }
.md__reason { height: 32px; padding: 0 12px; border-radius: 6px; border: 1px solid rgba(15, 23, 42, .14); font-size: .82rem; transition: all .15s; }
.md__reason:hover { border-color: var(--v-error-base); }
.md__reason--on { background: var(--v-error-base); border-color: var(--v-error-base); color: #fff; }
.md__foot { display: flex; gap: 10px; padding: 12px 18px; background: #fafbfd; border-top: 1px solid rgba(15, 23, 42, .07); }
.theme--dark .md__foot { background: #232323; }
.md ::v-deep .v-input { height: auto !important; }
.md ::v-deep fieldset { border-radius: 6px; }
</style>
